import { lazy, type ReactElement } from 'react'

export const LazyTwoStepVerificationPushResponse = lazy(() =>
  import('../pages/TwoStepVerification/Push/TwoStepVerificationPushResponse').then((module) => ({
    default: module.TwoStepVerificationPushResponse,
  })),
)

export const TwoStepVerificationPushResponseRoute = (): ReactElement => {
  return <LazyTwoStepVerificationPushResponse />
}